import { useEffect, useState } from 'react';
export function useAutoTextarea({ fieldRef, value, autoGrow, minRows = 3, maxRows, }) {
    const [limitedRows, setLimitedRows] = useState(autoGrow ? minRows : Math.max(...[minRows, maxRows].filter(Number)));
    const [currentRows, setCurrentRows] = useState(limitedRows);
    useEffect(() => {
        const textarea = fieldRef.current;
        if (!textarea || !autoGrow)
            return;
        const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight, 10);
        textarea.removeAttribute('rows');
        textarea.style.height = `${lineHeight}px`;
        const rows = Math.round(textarea.scrollHeight / lineHeight);
        let result = Math.round(textarea.scrollHeight / lineHeight);
        if (rows < minRows) {
            result = minRows;
        }
        if (rows > maxRows) {
            result = maxRows;
            textarea.style.overflowY = 'auto';
        }
        else {
            textarea.style.overflowY = 'hidden';
        }
        textarea.style.height = `${result * lineHeight}px`;
        setLimitedRows(result);
        setCurrentRows(rows);
    }, [fieldRef.current, value, autoGrow, minRows, maxRows]);
    return { limitedRows, currentRows };
}
